import CompactOffer from "@components/shared/compactOffer";
import { affiliateOfferZones } from "@lib/shared/config";
import { ListingItem } from "@lib/shared/types";
import { ReactElement } from "react";
import ThankYou from "@components/shared/thankyou";

interface InlineThankYouShortcutProps {
    formClassName: string | undefined;
    compactOfferBlock: ListingItem | undefined;
    hideOffers: boolean | undefined;
    customThankYouStep: ReactElement | undefined;
    innerThankYouClassName: string | undefined;
}

export default function InlineThankYouShortcut({
    formClassName,
    compactOfferBlock,
    hideOffers,
    customThankYouStep,
    innerThankYouClassName,
}: InlineThankYouShortcutProps): ReactElement {
    return (
        <div className={`${formClassName ?? ""} mx-auto`}>
            {compactOfferBlock && !hideOffers && (
                <CompactOffer
                    zone={affiliateOfferZones.THANK_YOU}
                    classes={{}}
                    showAllOffers
                />
            )}
            {customThankYouStep ?? (
                <ThankYou
                    inForm={true}
                    className={innerThankYouClassName ?? ""}
                />
            )}
        </div>
    );
}
